import React, { useState } from 'react';
import {
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Collapse,
	List,
	Box,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const MenuItemComponent = ({
	to,
	icon: Icon,
	primary,
	onClick,
	selected,
	subItems,
}) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	// Jos menuitemillä on alavalikko, käsitellään klikkaus eri tavalla
	const handleClick = (event) => {
		if (subItems && subItems.length > 0) {
			event.preventDefault(); // Estetään linkin toiminta
			setOpen(!open);
		} else if (onClick) {
			onClick();
		}
	};

	// Tarkistetaan onko tämä menu tai jokin sen alavalikko valittuna
	const isMenuSelected =
		selected ||
		(subItems &&
			subItems.some(
				(item) =>
					window.location.pathname === item.to ||
					window.location.pathname.startsWith(item.to),
			));

	return (
		<>
			<ListItemButton
				component={Link}
				to={to}
				onClick={handleClick}
				selected={isMenuSelected}
				sx={{
					borderRadius: 2,
					mb: 0.5,
					'&.Mui-selected': {
						backgroundColor: 'rgba(124, 85, 229, 0.08)',
						'&:hover': {
							backgroundColor: 'rgba(124, 85, 229, 0.12)',
						},
						'& .MuiListItemIcon-root': {
							color: theme.palette.primary.main,
						},
						'& .MuiTypography-root': {
							fontWeight: 600,
							color: theme.palette.primary.main,
						},
					},
				}}
			>
				<ListItemIcon>{Icon && <Icon />}</ListItemIcon>
				<ListItemText primary={primary} />
				{subItems &&
					subItems.length > 0 &&
					(open ? <ExpandLess /> : <ExpandMore />)}
			</ListItemButton>

			{/* Alavalikko */}
			{subItems && subItems.length > 0 && (
				<Collapse in={open} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						{subItems.map((subItem) => {
							const SubIcon = subItem.icon;
							const isSubItemSelected =
								window.location.pathname === subItem.to ||
								window.location.pathname.startsWith(subItem.to);

							return (
								<ListItemButton
									key={subItem.to}
									component={Link}
									to={subItem.to}
									onClick={onClick}
									selected={isSubItemSelected}
									sx={{
										pl: 4,
										borderRadius: 2,
										mb: 0.5,
										ml: 2,
										'&.Mui-selected': {
											backgroundColor:
												'rgba(124, 85, 229, 0.08)',
											'&:hover': {
												backgroundColor:
													'rgba(124, 85, 229, 0.12)',
											},
											'& .MuiListItemIcon-root': {
												color: theme.palette.primary
													.main,
											},
											'& .MuiTypography-root': {
												fontWeight: 600,
												color: theme.palette.primary
													.main,
											},
										},
									}}
								>
									<ListItemIcon>
										{SubIcon ? (
											<SubIcon />
										) : (
											<Box sx={{ width: 24 }} />
										)}
									</ListItemIcon>
									<ListItemText primary={subItem.primary} />
								</ListItemButton>
							);
						})}
					</List>
				</Collapse>
			)}
		</>
	);
};

export default MenuItemComponent;
